import React, {useEffect} from "react";
import './AnalizaMain.css';
import zbiory from "../images/zbiory.png"
import animacja from "../images/animacja.gif.gif"
import AiB from "../images/gif3.png"
import AlubB from "../images/gif2.png"
import AbezB from "../images/gif4.png"
import {Link, useHistory} from "react-router-dom";
import * as BiIcons from 'react-icons/bi';
import TeX from '@matejmazur/react-katex';

export default function FirstConcepts(){

    useEffect(()=>{
        document.title="Pojęcia wstępne";
    },[])

    const { push } = useHistory();

    const comeBackFunc=()=>{
        push('/analiza');
    }

    return(
      <div className='conceptsContainer'>
          <div className='comeBackDiv' onClick={comeBackFunc}>
              <BiIcons.BiArrowBack/>
              <div style={{textAlign: 'left', alignItems: 'left'}}>Cofnij</div>
          </div>

          <h1>Wprowadzenie</h1>
          <br/><br/>

          <h2>Zbiory i ich oznaczanie</h2>
          <br/>

          <p>Jeżeli chcemy napisać, że element a nalęży do zbioru A stosujemy zapis:</p>
          <p><TeX math={'a'}/> &#8712; A,</p>
          <p>Jeżeli jednak a nie należy to oznaczamy to:</p>
          <p><TeX math={'a'}/> &#8713; A.</p>

          <br/>

          <p>Zapis</p>
          <p>A &#8834; B lub B &#8835; A</p>
          <p>oznacza, że zbiór A jest zawarty w zbiorze B, tzn. każdy element zbioru A jest elementem zbioru B, czyli
          A jest podzbiorem B lub B jest nadzbiorem A.</p>
          <img src={zbiory}  className='image'/>

          <h2>Jeśli wprowadzimy oznaczenia zbiorów:</h2>
          <p>P - zbiór liczb parzystych dodatnich</p>
          <p>Q - zbiór liczb nieparzystych dodatnich</p>
          <p>to możemy wprowadzić zapis:</p>
          <p><TeX math={'x'}/> &#8712; X : S(<TeX math={'x'}/>), gdzie S(<TeX math={'x'}/>) jest to funkcja zdaniowa</p>
          <p>i dla przykładu zapis:</p>
          <p><TeX math={'x'}/> &#8712; P : 1&#60;<TeX math={'x'}/>&#60;8</p>
          <p>oznacza liczby: 2, 4, 6,</p><br/>
          <p><TeX math={'x'}/> &#8712; Q : <TeX math={'x^2'}/>&#60;16,</p>
          <p>oznacza liczby: 1,3.</p>

        <br/><br/><br/>
        <h1>Logika w zbiorach</h1>

        <Link to="/analiza/pojecia-wstepne/logika"><button>Podstawy logiki</button></Link>

        <p><img className='image' src={AlubB}/></p>
        <p><TeX math={'x'}/> &#8712; A &#8746; B, inaczej: <TeX math={'x'}/> &#8712; A &#8744; <TeX math={'x'}/> &#8712; B</p>
        <br/>
        <p><img className='image' src={AiB}/></p>
        <p><TeX math={'x'}/> &#8712; A &#8745; B, inaczej: <TeX math={'x'}/> &#8712; A &#8743; <TeX math={'x'}/> &#8712; B</p>
        <br/>
        <p><img className='image' src={AbezB}/></p>
        <p><TeX math={'x'}/> &#8712; A \ B, inaczej: <TeX math={'x'}/> &#8712; A &#8743; <TeX math={'x'}/> &#8713; B</p>
          <p><img className='image' src={animacja}/></p>
          <br/><br/>

        <Link to="/analiza/pojecia-wstepne/kwantyfikatory"><button>Kwantyfikatory</button></Link><br/>
        <Link to="/analiza/pojecia-wstepne/relacje"><button>Relacje</button></Link><br/>
        <Link to="/analiza/pojecia-wstepne/nierownosci-1-stopnia-1"><button>Nierówności 1-stopnia z jedną niewiadomą</button></Link><br/>
        <Link to="/analiza/pojecia-wstepne/dwumian-Newtona"><button>Dwumian Newtona</button></Link><br/>
        <Link to="/analiza/pojecia-wstepne/ciagi-nieskonczone"><button>Ciagi nieskonczone</button></Link><br/>
        <Link to="/analiza/pojecia-wstepne/szeregi-liczbowe"><button>Szeregi liczbowe</button></Link><br/>

      </div>
    );
}


